export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14747.fe3dfb2e.jpg";